import script from "./TherapistsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./TherapistsSection.vue?vue&type=script&setup=true&lang=js"

import "./TherapistsSection.vue?vue&type=style&index=0&id=1f3c567c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f3c567c"]])

export default __exports__